var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{attrs:{"label":"Date of Birth","append-icon":"mdi-calendar","clearable":"","color":_vm.themes.candidate.light.input,"theme":_vm.themes.candidate.light},on:{"input":_vm.submit,"focus":_vm.initialize},model:{value:(_vm.profile.bornAt),callback:function ($$v) {_vm.$set(_vm.profile, "bornAt", $$v)},expression:"profile.bornAt"}})
}
var staticRenderFns = []

export { render, staticRenderFns }